<template>
  <svg
    v-if="!isOpened"
    :width="width"
    :height="height"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M320,96H88a40,40,0,0,0-40,40V376a40,40,0,0,0,40,40H422.73a40,40,0,0,0,40-40V239"
      style="fill: none; stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32;"
    />
    <polyline
      points="112 160 256 272 343 206.33"
      style="fill: none; stroke: #000; stroke-linecap: round; stroke-linejoin: round; stroke-width: 32;"
    />
    <circle :cx="431.95" :cy="128.05" :r="47.95" />
    <path
      d="M432,192a63.95,63.95,0,1,1,63.95-63.95A64,64,0,0,1,432,192Zm0-95.9a32,32,0,1,0,31.95,32A32,32,0,0,0,432,96.1Z"
    />
  </svg>
  <svg
    v-else
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    id="Icons"
    :width="width"
    :height="height"
    fill="none"
    xml:space="preserve"
  >
    <polyline stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :stroke="color" points="3,10 16,18 29,10" />
    <path
      fill="none" :stroke="color" stroke-width="2"
      d="M29,10v13c0,2.2-1.8,4-4,4H7c-2.2,0-4-1.8-4-4V10l13-9L29,10z"
    />
  </svg>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class WcIconMessage extends Vue {
  @Prop({ required: true }) isOpened!: boolean
  @Prop({ default: '#09121F' }) color!: string
  @Prop({ default: '16' }) height!: string
  @Prop({ default: '16' }) width!: string
}
</script>

<style scoped>

</style>
